import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, Grid, MenuItem, Pagination, Select, Stack } from "@mui/material";
import { contentBoxStyle } from "../shared/Theme";
import RiskOverviewGraph from "../elements/CyberRisk/RiskOverviewGraph";
import Sidebar from "../elements/Sidebar";
import Header from "../elements/Header";
import RiskCard from "../elements/CyberRisk/RiskCard";
import RiskCardModal from "../elements/CyberRisk/RiskCardModal";
import ragService from "../services/ragService";
import companyService from "../services/companyService";
import AccountGuard from "../elements/Admin/AccountGuard";
import CompleteRagsModal from "../elements/CyberRisk/CompleteRagsModal";
import {Warning} from "@mui/icons-material";
import {red, amber} from "../shared/colours";

const Rags = () => {
	
	let [ pagedRisks, setPagedRisks ] = useState([]);
	let [ selectedRisk, setSelectedRisk ] = useState(null);
	let [ risks, setRisks ] = useState(ragService.rags);
	let [ riskCounts, setRiskCounts ] = useState({red: 0, amber: 0, green: 0});
	let [ showCompleteRagsModel, setShowCompleteRagsModel ] = useState(false);
	let [ filterRiskLevel, setFilterRiskLevel ] = useState(0);
	let [ filterRiskType, setFilterRiskType ] = useState(0);
	let [ page, setPage ] = useState(1);
	let [ pageCount, setPageCount ] = useState(0);
	let [ ragCounts, setRagCounts ] = useState({
		0: 0,
		1: 0,
		2: 0,
		3: 0,
		certificate: 0,
		email: 0,
		phishing: 0,
		ransomware: 0,
		service: 0,
		sld: 0
	});
	
	const handleFilterRiskLevelChange = (e) => {
		setFilterRiskLevel(e.target.value);
		setPage(1);
		updatePagedRisks(1, e.target.value, filterRiskType);
	};

	const handleFilterRiskTypeChange = (e) => {
		setFilterRiskType(e.target.value);
		setPage(1);
		updatePagedRisks(1, filterRiskLevel, e.target.value);
	};

	const handleRiskReadMore = (risk) => {
		setSelectedRisk(risk);
	};
	
	const handleRiskCardModalClose = (updated = false) => {
		setSelectedRisk(null);
		if (updated) {
			setRisks(ragService.rags);
		}
	};
	
	const handlePaginationChange = (e, newPage) => {
		setPage(newPage);
		updatePagedRisks(newPage, filterRiskLevel, filterRiskType);
	};
	
	const updatePagedRisks = (newPage, newFilterRiskLevel, newFilterRiskType) => {
		const filteredRisks = [];
		const newRagCounts = {
			0: 0,
			1: 0,
			2: 0,
			3: 0,
			certificate: 0,
			email: 0,
			phishing: 0,
			ransomware: 0,
			service: 0,
			sld: 0
		};

		for (let i = 0; i < risks.length; i++) {
			if (risks[i].severity === 0) continue;
			if (newFilterRiskLevel !== 0 && newFilterRiskLevel !== (risks[i].severity + 1)) continue;
			if (newFilterRiskType !== 0 && newFilterRiskType !== risks[i].category) continue;
			filteredRisks.push(risks[i]);
		}

		for (let i = 0; i < risks.length; i++) {
			if (risks[i].severity === 0) continue;
			if (newFilterRiskType !== 0 && newFilterRiskType !== risks[i].category) continue;
			newRagCounts[0] += 1;
			newRagCounts[risks[i].severity + 1] += 1;
		}

		for (let i = 0; i < risks.length; i++) {
			if (risks[i].severity === 0) continue;
			if (newFilterRiskLevel !== 0 && newFilterRiskLevel !== (risks[i].severity + 1)) continue;
			newRagCounts[risks[i].category] += 1;
		}

		setRagCounts(newRagCounts);

		let newPageCount = Math.floor(filteredRisks.length / 10) + 1;
		if (newPageCount > 1 && filteredRisks.length % 10 === 0) newPageCount -= 1;
		setPageCount(newPageCount);

		let fromIndex = 0;
		let toIndex = 0;
	
		fromIndex = 10 * (newPage - 1);
		toIndex = (filteredRisks.length >= newPage * 10)? newPage * 10 : filteredRisks.length;
		
		const newPagedRisks = [];
		for (let i = fromIndex; i < toIndex; i++) {
			newPagedRisks.push(filteredRisks[i]);
		}
		
		setPagedRisks(newPagedRisks);
	}

	useEffect(() => {
		setRiskCounts(ragService.ragCounts);

		const filteredRisks = [];
		for (let i = 0; i < risks.length; i++) {
			if (risks[i].severity === 0) continue;
			filteredRisks.push(risks[i])
		}
		
		let fromIndex = 0;
		let toIndex = (filteredRisks.length >= 10)? 10 : filteredRisks.length;
		
		const newRagCounts = {
			0: 0,
			1: 0,
			2: 0,
			3: 0,
			certificate: 0,
			email: 0,
			phishing: 0,
			ransomware: 0,
			service: 0,
			sld: 0
		};
		for (let i = 0; i < filteredRisks.length; i++) {
			newRagCounts[0] += 1;
			newRagCounts[filteredRisks[i].severity + 1] += 1;
			newRagCounts[filteredRisks[i].category] += 1;
		}

		const newPagedRisks = [];
		for (let i = fromIndex; i < toIndex; i++) {
			if (filteredRisks[i].severity === 0) continue;
			newPagedRisks.push(filteredRisks[i]);
		}
		
		let newPageCount = Math.floor(filteredRisks.length / 10) + 1;
		if (newPageCount > 1 && filteredRisks.length % 10 === 0) newPageCount -= 1;
		setRagCounts(newRagCounts);
		setPageCount(newPageCount);
		setPagedRisks(newPagedRisks);
	}, [risks]);
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			setRisks(ragService.rags);
		});
	}, []);
	
	const handleShowComplete = () => {
		setShowCompleteRagsModel(true);
	};
	
	const handleCompleteRagsModalClose = () => {
		setShowCompleteRagsModel(false);
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Sidebar/>
			<AccountGuard requiredService="kynd"/>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Header pageTitle="Cyber Risk"/>
				<Box sx={contentBoxStyle}>
					<Stack direction="column" spacing="2">
						<Stack direction="row" spacing="2" justifyContent="center" sx={{ marginBottom: "2em" }}>
							<RiskOverviewGraph
								value={riskCounts.red}
								total={50}
								label="items"
								size="15em"
								colorOverride="red"
							/>
							<RiskOverviewGraph
								value={riskCounts.amber}
								total={50}
								label="items"
								size="15em"
								colorOverride="amber"
							/>
						</Stack>
						<Stack direction="row" spacing="1em" justifyContent="flex-end" sx={{ width: "100%", padding: "2em" }}>
							<Select
								value={filterRiskLevel}
								alignItems="center"
								onChange={handleFilterRiskLevelChange}
								renderValue={(selected) => {
									if (selected === 3) {
										return (
											<>High ({ragCounts[3]})</>
										);
									}
									else if (selected === 2) {
										return (
											<>Medium ({ragCounts[2]})</>
										);
									}
									else {
										return (
											<>All risk levels</>
										);
									}
								}}
							>
								<MenuItem value={0}>All risk levels</MenuItem>
								<MenuItem value={3}>
									<Warning sx={{ color: red, marginRight: "0.5em" }}/>
									High ({ragCounts[3]})
								</MenuItem>
								<MenuItem value={2}>
									<Warning sx={{ color: amber, marginRight: "0.5em" }}/>
									Medium ({ragCounts[2]})
								</MenuItem>
							</Select>
							<Select value={filterRiskType} alignItems="center" onChange={handleFilterRiskTypeChange}>
								<MenuItem value={0}>All risk types</MenuItem>
								<MenuItem value="certificate">Certificate risks ({ragCounts.certificate})</MenuItem>
								<MenuItem value="email">Email risks ({ragCounts.email})</MenuItem>
								<MenuItem value="phishing">Phishing risks ({ragCounts.phishing})</MenuItem>
								<MenuItem value="ransomware">Ransomware risks ({ragCounts.ransomware})</MenuItem>
								<MenuItem value="service">Service risks ({ragCounts.service})</MenuItem>
								<MenuItem value="sld">Domain risks ({ragCounts.sld})</MenuItem>
							</Select>
						</Stack>
						{pagedRisks.length > 0 ?
							<Stack direction="column" justifyContent="center">
								<Grid container spacing={2} justifyContent="center">
									{pagedRisks.map((risk, index) => {
										return (
											<Grid item key={`risk_${index}`}>
												<RiskCard
													risk={risk}
													width={260}
													height={250}
													onReadMore={handleRiskReadMore}
												/>
											</Grid>
										);
									})}
								</Grid>
								<Box sx={{ width: "344px", margin: "1em auto" }}>
									<Pagination
										page={page}
										//count={Math.floor((riskCounts.red + riskCounts.amber) / 10) + 1}
										count={pageCount}
										onChange={handlePaginationChange}
									/>
								</Box>
								<Stack direction="row" justifyContent="flex-end">
									<Button
										onClick={handleShowComplete}
										sx={{
											width: "10em"
										}}
									>
										Show Complete
									</Button>
								</Stack>
							</Stack>
						: <React.Fragment/> }
						<CompleteRagsModal
							completedRags={ragService.completedRags}
							show={showCompleteRagsModel}
							onCompletedRagClick={(rag) => { handleRiskReadMore(rag); }}
							onClose={handleCompleteRagsModalClose}
						/>
						<RiskCardModal
							risk={selectedRisk}
							onClose={handleRiskCardModalClose}
						/>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
}

export default Rags;
